

















import { Component } from 'vue-property-decorator';
import BaseModal from './BaseModal.vue';

@Component({ components: { BaseModal } })
export default class MessageModal extends BaseModal {}
